import { createSlice } from "@reduxjs/toolkit"
import VwHbsIslemtanimDTO from "src/models/GenelTanimlar/VwHbsIslemtanimDTO";
import VwHbsRaportiptanimverigirisDTO from "src/models/PatolojiModul/VwHbsRaportiptanimverigirisDTO";
import HbsRaportiptanimDTO from "src/models/Raporlama/HbsRaportiptanimDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads"
interface RaporlamaTanimState {
    activeRow: HbsRaportiptanimDTO,
    open: boolean,
    raporGrupOpen: boolean;
    islemTanimRow: VwHbsIslemtanimDTO;
    raporGrupActiveRow: VwHbsRaportiptanimverigirisDTO;
    protokolGrupDialog: boolean;
}

const RaporlamaTanimSlice = createSlice<RaporlamaTanimState, MapReducerPayloads<RaporlamaTanimState, {
    setState: RaporlamaTanimState
}>>({
    name: "RaporlamaTanim",
    initialState: {
        activeRow: new HbsRaportiptanimDTO(),
        open: false,
        raporGrupOpen: false,
        islemTanimRow: new VwHbsIslemtanimDTO(),
        raporGrupActiveRow: new VwHbsRaportiptanimverigirisDTO(),
        protokolGrupDialog: false
    },
    reducers: {
        setState: (state, action) => action.payload
    }
})

export default RaporlamaTanimSlice